import store from '@/store/index.js'

export function validateAdditionalField(
  group,
  field,
  value,
  getCountryCode,
  $t,
  fieldsConfig,
  getFieldPropertyValue,
  additionalInfo
) {
  if (value === null) value = ''

  value = value?.trim().replace(/\s\s+/g, ' ')

  if (getCountryCode === 'PL' && field === 'FAKTURA_POSTINDEX') {
    let numbers = value.replace(/\D/g, '')

    if (numbers.length <= 2) {
      value = numbers
    } else if (numbers.length > 2 && numbers.length <= 5) {
      value = `${numbers.slice(0, 2)}-${numbers.slice(2)}`
    } else if (numbers.length > 5) {
      value = numbers.slice(0, 6)
    }

    additionalInfo[field] = value
  }

  store.commit('setUserAdditionalFields', { field, error: false })

  const isRequired = getFieldPropertyValue(group, field, 'required')

  if (isRequired) {
    if (!value || !value.length) {
      store.commit('setUserAdditionalFields', { field, error: $t('fill_that_field') })
    }
  }

  validateAdditionalFieldInside(fieldsConfig, additionalInfo, $t)
}

function validateAdditionalFieldInside(fieldsConfig, profile, $t) {
  const notFilled = []
  const notFilledLabels = []
  let r = true

  if (fieldsConfig.ADDRESS_INFO_FIELDS) {
    if (fieldsConfig.ADDITIONAL_FIELDS) {
      fieldsConfig.ADDITIONAL_FIELDS.forEach((item) => {
        if (item.required && item.visual && item.type === 'text') {
          r = Boolean(
            profile[item.name] && profile[item.name]?.trim().length > 0
          )

          if (!r && !notFilled.includes(item.name)) {
            notFilled.push(item.name)
            notFilledLabels.push(item.label)
          }
        }
      })
    }
  } else {
    console.log('wrong fieldsConfig')
  }

  if (notFilled.length > 0) {
    store.commit(
      'setCourierAddressAdditionalFieldError',
      $t('hidden_fields_error') + ': ' + notFilledLabels.join(', ')
    )
  } else {
    store.commit('setCourierAddressAdditionalFieldError', false)

    return true
  }

  return false
}
